import type { IconName } from '@/types'

export type NavItem = {
    href: string
    label: string
    icon: IconName
    aliases?: string[]
    badge?: 'favorites' | 'mine'
}

export type NavGroup = {
    title: string
    items: NavItem[]
}

export const PRIMARY_ACTION: NavItem = {
    href: '/new',
    label: 'ثبت دانش جدید',
    icon: 'file-plus-2'
}

export const NAV_GROUPS: NavGroup[] = [
    {
        title: 'کشف دانش',
        items: [
            { href: '/', label: 'صفحه اصلی', icon: 'house' },
            { href: '/knowledge', label: 'همه دانش‌ها', icon: 'library', aliases: ['/search'] },
            { href: '/categories', label: 'دسته‌بندی دانش‌ها', icon: 'layout-grid' },
            { href: '/categories/technical', label: 'دانش‌های تخصصی', icon: 'cpu' },
            { href: '/lessons', label: 'درس‌آموخته‌ها', icon: 'notebook-pen' },
            { href: '/learning', label: 'آموزش و یادگیری', icon: 'graduation-cap' },
            { href: '/faq', label: 'پرسش‌های پرتکرار', icon: 'circle-help' }
        ]
    },
    {
        title: 'فضای من',
        items: [
            { href: '/me', label: 'دانش‌های من', icon: 'folder-open', badge: 'mine' },
            { href: '/saved', label: 'علاقه‌مندی‌ها', icon: 'bookmark', badge: 'favorites' }
        ]
    }
]

const matches = (path: string, href: string): boolean => {
    if (href === '/') return path === '/'

    return path === href || path.startsWith(`${href}/`)
}

/** Picks the single most specific nav entry for the current path. */
export const activeNavHref = (path: string): string | null => {
    const candidates = [PRIMARY_ACTION, ...NAV_GROUPS.flatMap(group => group.items)]
    let best: { href: string, length: number } | null = null

    for (const item of candidates) {
        for (const target of [item.href, ...(item.aliases ?? [])]) {
            if (matches(path, target) && (!best || target.length > best.length)) {
                best = { href: item.href, length: target.length }
            }
        }
    }

    return best?.href ?? null
}
